module.exports = __webpack_public_path__ + "img/arrow-right-1.31e69ba1.svg";